import React, { useState, useEffect } from 'react'

const Timer = ({ linkExpirationTime, active = false, expiryTime }) => {
  const calculateTimeLeft = () => {
    let timeLeftObj = {}
    const expiryTimeInSeconds = expiryTime * 60 * 60
    if (!active) {
      timeLeftObj = {
        days: `0${Math.floor((expiryTimeInSeconds / (24 * 60 * 60)))}`,
        hrs: `${(expiryTimeInSeconds / (60 * 60)) % 24 < 10 ? '0' : ''}${Math.floor((expiryTimeInSeconds / (60 * 60)) % 24)}`,
        mins: `${(expiryTimeInSeconds / (60)) % 60 < 10 ? '0' : ''}${Math.floor((expiryTimeInSeconds / (60)) % 60)}`,
        secs: `${expiryTimeInSeconds % 60 < 10 ? '0' : ''}${Math.floor(expiryTimeInSeconds % 60)}`
      }
      return timeLeftObj
    }
    const diff = linkExpirationTime - new Date().getTime()
    if (diff > 0) {
      const days = Math.floor((diff / (24 * 1000 * 60 * 60)))
      const hour = Math.floor((diff / (1000 * 60 * 60)) % 24)
      const minutes = Math.floor((diff / 1000 / 60) % 60)
      const seconds = Math.floor((diff / 1000) % 60)
      timeLeftObj = {
        days: days >= 10 ? days : `0${days}`,
        hrs: hour >= 10 ? hour : `0${hour}`,
        mins: minutes >= 10 ? minutes : `0${minutes}`,
        secs: seconds >= 10 ? seconds : `0${seconds}`
      }
    } else if (Math.abs(diff) / 1000 <= 2) {
      timeLeftObj = {
        days: '00',
        hrs: '00',
        mins: '00',
        secs: '00'
      }
      window.location.reload()
    } else {
      timeLeftObj = {
        days: '00',
        hrs: '00',
        mins: '00',
        secs: '00'
      }
    }
    return timeLeftObj
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    if (active) {
      const timer = setTimeout(() => {
        setTimeLeft(calculateTimeLeft())
      }, 1000)

      return () => clearTimeout(timer)
    }
  })

  const timerComponents = []

  const styleObj = {
    height: '72px',
    width: '64px',
    borderRadius: '8px',
    padding: '8px',
    backgroundColor: '#F2FAF0',
  }
  Object.keys(timeLeft).forEach((interval, index) => {
    if (timeLeft[interval] < 0 || timeLeft[interval] === null || timeLeft[interval] === undefined) {
      return
    }

    timerComponents.push(
      <div className="flex flex-row flex-middle ">
        <div className={`ta-c flex flex-middle flex-center flex-column  ${interval !== 'secs' ? 'mr-2' : ''}`} style={styleObj}>
          <span className="color-neutral-900 fs-24 lh-28 fw-500">
            {timeLeft[interval]}
          </span>
          <span className="fw-500 fs-2 tt-uppercase pt-1 color-neutral-900">
            {interval}
          </span>
        </div>

        <span />
      </div>

    )
  })

  return (
    <React.Fragment>
      <div className="flex flex-row flex-middle">
        {timerComponents.length ? timerComponents : null}
      </div>
    </React.Fragment>
  )
}

export default Timer
